<div class="item-images-grid">
    @for (doc of files; track doc.id) {
        <div class="item-images-card">
            <div class="item-images-card__thumb-slot">
                @if (doc.fileId || doc.url) {
                    <pf-document-file-thumb
                        [document]="doc"
                        [parentId]="parentId"
                        [fallbackUrl]="doc.url"
                        [alt]="doc.fileName ?? 'Item image'" />
                }
                @if (doc.fileId || doc.url) {
                    <button
                        type="button"
                        class="item-images-card__preview-btn"
                        (click)="openPreview(doc, files)"
                        [attr.aria-label]="
                            'Preview ' + (doc.fileName ?? 'image')
                        ">
                        <span class="item-images-card__preview-overlay">
                            <pf-icon iconType="view" size="md"></pf-icon>
                            <span class="item-images-card__preview-label"
                                >Preview</span
                            >
                        </span>
                    </button>
                }
            </div>
            <div class="item-images-card__meta">
                <span class="item-images-card__name">{{ listLabel(doc) }}</span>
                <div
                    class="item-images-card__actions"
                    role="group"
                    aria-label="Image actions">
                    <div
                        class="item-images-card__action-cell item-images-card__action-cell--primary">
                        @if (!doc.isDefault) {
                            <button
                                type="button"
                                class="item-images-card__icon-btn item-images-card__icon-btn--primary"
                                (click)="setPrimary(doc)"
                                [disabled]="settingPrimaryFileId === doc.id"
                                title="Set as primary"
                                [attr.aria-label]="
                                    'Set as primary: ' +
                                    (doc.fileName ?? 'image')
                                ">
                                <pf-icon iconType="item" size="md"></pf-icon>
                            </button>
                        } @else {
                            <span
                                class="item-images-card__action-static"
                                title="Primary thumbnail"
                                role="img"
                                aria-label="Primary thumbnail">
                                <pf-icon iconType="success" size="md"></pf-icon>
                            </span>
                        }
                    </div>
                    <div
                        class="item-images-card__action-cell item-images-card__action-cell--remove">
                        <button
                            type="button"
                            class="item-images-card__icon-btn item-images-card__icon-btn--danger"
                            (click)="removeDoc(doc)"
                            title="Remove image"
                            [attr.aria-label]="
                                'Remove image: ' + (doc.fileName ?? 'image')
                            ">
                            <pf-icon iconType="close" size="md"></pf-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }
    @if (files.length < maxImages) {
        <div class="item-images-upload-cell">
            <nz-spin [nzSpinning]="imageUploading">
                <nz-upload
                    class="item-images-nz-upload"
                    nzListType="picture-card"
                    [nzFileList]="[]"
                    [nzShowUploadList]="false"
                    [nzBeforeUpload]="beforeUpload"
                    [nzDisabled]="imageUploading"
                    [nzShowButton]="true"
                    [nzAccept]="accept"
                    [nzMultiple]="false">
                    <div class="item-upload-card-trigger">
                        <pf-icon iconType="plus" size="md"></pf-icon>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </nz-upload>
            </nz-spin>
        </div>
    }
</div>

<nz-modal
    [(nzVisible)]="previewVisible"
    nzTitle="Image preview"
    [nzFooter]="null"
    [nzCentered]="!previewCompactViewport"
    [nzWidth]="previewCompactViewport ? '100%' : 880"
    [nzStyle]="previewModalNzStyle"
    [nzBodyStyle]="previewModalBodyStyle"
    (nzOnCancel)="closePreview()">
    <ng-container *nzModalContent>
        <div
            class="item-image-preview-modal"
            [class.item-image-preview-modal--compact]="previewCompactViewport">
            @if (previewShowGalleryChrome) {
                <div class="item-image-preview-modal__count" aria-live="polite">
                    {{ previewIndex + 1 }} of {{ previewGallery.length }}
                </div>
            }
            @if (previewActiveDoc; as previewDoc) {
                <div class="item-image-preview-modal__meta" aria-live="polite">
                    <span class="item-image-preview-modal__file-name">{{
                        previewDoc.fileName?.trim() || "Image"
                    }}</span>
                    <span
                        class="item-image-preview-modal__primary"
                        [class.item-image-preview-modal__primary--is-default]="
                            previewDoc.isDefault
                        ">
                        {{
                            previewDoc.isDefault
                                ? "Primary list image"
                                : "Not primary"
                        }}
                    </span>
                </div>
            }
            <div class="item-image-preview-modal__main">
                @if (previewShowGalleryChrome) {
                    <button
                        type="button"
                        class="ant-btn ant-btn-default item-image-preview-modal__nav item-image-preview-modal__nav--prev"
                        (click)="previewPrev()"
                        aria-label="Previous image">
                        ‹
                    </button>
                }
                <div class="item-image-preview-modal__stage">
                    @if (previewLoading) {
                        <div class="item-image-preview-modal__loading">
                            <nz-spin nzSimple></nz-spin>
                        </div>
                    } @else if (previewSrc) {
                        <img
                            class="item-image-preview-modal__img"
                            [src]="previewSrc"
                            [alt]="previewAlt" />
                    }
                </div>
                @if (previewShowGalleryChrome) {
                    <button
                        type="button"
                        class="ant-btn ant-btn-default item-image-preview-modal__nav item-image-preview-modal__nav--next"
                        (click)="previewNext()"
                        aria-label="Next image">
                        ›
                    </button>
                }
            </div>
            @if (previewShowGalleryChrome) {
                <div
                    class="item-image-preview-modal__thumbs"
                    aria-label="Image thumbnails">
                    @for (thumb of previewGallery; track thumb.id) {
                        <button
                            type="button"
                            class="item-image-preview-modal__thumb"
                            [class.item-image-preview-modal__thumb--active]="
                                $index === previewIndex
                            "
                            (click)="goToGalleryIndex($index)"
                            [attr.aria-label]="
                                'Image ' +
                                ($index + 1) +
                                (thumb.fileName ? ': ' + thumb.fileName : '')
                            "
                            [attr.aria-current]="
                                $index === previewIndex ? 'true' : null
                            ">
                            @if (thumb.fileId || thumb.url) {
                                <pf-document-file-thumb
                                    class="item-image-preview-modal__thumb-img"
                                    [document]="thumb"
                                    [parentId]="parentId"
                                    [fallbackUrl]="thumb.url"
                                    [alt]="thumb.fileName ?? 'Thumbnail'" />
                            }
                        </button>
                    }
                </div>
            }
        </div>
    </ng-container>
</nz-modal>
